import { render, staticRenderFns } from "./BoxFormGemeos.vue?vue&type=template&id=305f2666&"
import script from "./BoxFormGemeos.vue?vue&type=script&lang=js&"
export * from "./BoxFormGemeos.vue?vue&type=script&lang=js&"
import style0 from "./BoxFormGemeos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports